import {
  SITE_DOCUMENTATION_ACCORDION_KEYS,
  SiteDocumentationAccordionSectionKey,
  SiteDocumentationAccordionState,
} from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.constants';
import { SiteTabs } from 'src/components/SidePanelTabs/SiteTab/site-const';
import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SiteViewState {
  selectedSiteTab: SiteTabs;
  setSelectedSiteTab: (item: SiteTabs) => void;
  siteSidePanelStateOpen: boolean;
  setSiteSidePanelStateOpen: (data: boolean) => void;
  siteDocumentationAccordionState: Record<string, SiteDocumentationAccordionState>;
  setSiteDocumentationAccordionState: (
    userId: string | null | undefined,
    state: SiteDocumentationAccordionState,
  ) => void;
}

export const createSiteViewSlice: StateCreator<SiteViewState, [], [], SiteViewState> = (
  set,
) => ({
  selectedSiteTab: SiteTabs.Clients,
  setSelectedSiteTab: (selectedSiteTab) => set({ selectedSiteTab }),
  siteSidePanelStateOpen: true,
  setSiteSidePanelStateOpen: (data) =>
    set(() => ({
      siteSidePanelStateOpen: data,
    })),
  siteDocumentationAccordionState: {},
  setSiteDocumentationAccordionState: (userId, state) => {
    const key = userId ?? 'default';
    set((prev) => {
      const current = prev.siteDocumentationAccordionState[key];
      const hasChanges = SITE_DOCUMENTATION_ACCORDION_KEYS.some(
        (sectionKey: SiteDocumentationAccordionSectionKey) =>
          current?.[sectionKey] !== state[sectionKey],
      );

      if (!hasChanges) {
        return {};
      }

      return {
        siteDocumentationAccordionState: {
          ...prev.siteDocumentationAccordionState,
          [key]: { ...state },
        },
      };
    });
  },
});

const useSiteViewsStore = create<SiteViewState>()(
  persist(
    (...args) => ({
      ...createSiteViewSlice(...args),
    }),
    {
      name: 'portal-site-view-store',
    },
  ),
);

export default useSiteViewsStore;
